module.exports = __webpack_public_path__ + "img/pd-img28.5bae61d7.png";